import React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from 'react-router-dom';
import ListBotTemplates from './pages/ListBotTemplates';
import ListBotInstances from './pages/ListBotInstances';
import BotTemplateConfig from './pages/BotTemplateConfig';
import CampaignMessages from './pages/CaseCampaignMessages';
import CaseListBots from './pages/CaseListBots';
import CaseUserDataTypes from './pages/CaseUserDataTypes';
import BotAdvancedConfig from './pages/BotAdvancedConfig';
import Errors from './pages/CaseErrorsConfig';
import Home from './pages/CaseHome';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import NavBar from './components/navBar/NavBar';
import { EnvProvider } from './components/Context/EnvProvider';
import { Auth0Provider } from '@auth0/auth0-react';
import { AUTH0_AUDIENCE, AUTH0_SCOPE } from './constants';

const App = () => (
    <div>
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN || 'lifty.us.auth0.com'}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || 'hybBR6Rnf0EjCwsTpkTK4cNuvBJcxhiI'}
            redirectUri={window.location.origin}
            audience={process.env.REACT_APP_AUTH0_AUDIENCE || AUTH0_AUDIENCE}
            scope={AUTH0_SCOPE}
        >
            <Router>
                <EnvProvider>
                    <NavBar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/BotTemplate" element={<BotTemplateConfig />} />
                        <Route path="/ListBotInstances" element={<ListBotInstances />} />
                        <Route path="/AdvancedConfig" element={<BotAdvancedConfig />} />
                        <Route path="/ListBotTemplates" element={<ListBotTemplates />} />
                        <Route path="/ListBots" element={<CaseListBots />} />
                        <Route path="/UserDataTypes" element={<CaseUserDataTypes />} />
                        <Route path="/CampaignMessages" element={<CampaignMessages />} />
                        <Route path="/Errors" element={<Errors />} />
                    </Routes>
                </EnvProvider>
            </Router>
        </Auth0Provider>
    </div>
);

export default App;
